<app-tab-layout [loading]="loading()" [error]="error">
  @if(initialized()) {
  <app-api-table
    [endpoint]="'/visits/tables/samples'"
    [name]="name"
    [hasIndexCol]="true"
    [chartColumn]="'Catalogue'"
    [onRowClick]="onRowClick"
  ></app-api-table>
  }
</app-tab-layout>
